customElements.get('next-drop-hero-video') || customElements.define('next-drop-hero-video', class extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('.js-next-drop-hero-video');
    this.playButton = this.querySelector('.js-next-drop-hero-play-button');
    this.soundButton = this.querySelector('.js-next-drop-hero-sound-button');
    this.handlePlayClick = this.handlePlayClick.bind(this);
    this.handleSoundClick = this.handleSoundClick.bind(this);
    this.syncPlayState = this.syncPlayState.bind(this);
  }

  connectedCallback() {
    if (!this.video) return;

    if (this.playButton) this.playButton.addEventListener('click', this.handlePlayClick);
    if (this.soundButton) this.soundButton.addEventListener('click', this.handleSoundClick);

    this.video.addEventListener('play', this.syncPlayState);
    this.video.addEventListener('pause', this.syncPlayState);

    // Reflect the video's real state (paused, by default) before attempting autoplay,
    // so the controls are correct even if autoplay is blocked or never attempted.
    this.syncPlayState();

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.attemptPlay();
    }
  }

  disconnectedCallback() {
    if (this.playButton) this.playButton.removeEventListener('click', this.handlePlayClick);
    if (this.soundButton) this.soundButton.removeEventListener('click', this.handleSoundClick);
    if (this.video) {
      this.video.removeEventListener('play', this.syncPlayState);
      this.video.removeEventListener('pause', this.syncPlayState);
    }
  }

  attemptPlay() {
    const playPromise = this.video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => this.syncPlayState());
    }
  }

  handlePlayClick() {
    if (!this.video) return;
    if (this.video.paused) {
      this.attemptPlay();
    } else {
      this.video.pause();
    }
  }

  handleSoundClick() {
    if (!this.video || !this.soundButton) return;
    this.video.muted = !this.video.muted;
    this.soundButton.classList.toggle('next-drop-hero__control-button--muted', this.video.muted);
    this.soundButton.setAttribute('aria-pressed', this.video.muted ? 'true' : 'false');
    this.soundButton.setAttribute(
      'aria-label',
      this.video.muted
        ? this.soundButton.dataset.unmuteLabel || 'Unmute video'
        : this.soundButton.dataset.muteLabel || 'Mute video'
    );
  }

  syncPlayState() {
    if (!this.video || !this.playButton) return;
    const isPaused = this.video.paused;
    this.playButton.classList.toggle('next-drop-hero__control-button--paused', isPaused);
    this.playButton.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
    this.playButton.setAttribute(
      'aria-label',
      isPaused
        ? this.playButton.dataset.playLabel || 'Play video'
        : this.playButton.dataset.pauseLabel || 'Pause video'
    );
  }
});
